import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { useTranslations } from "../../i18n";
import { clsx } from "clsx";
import { Skeleton } from "../Skeleton";
import { Spinner } from "../Spinner";
import { ComboBoxItem } from "./ComboBoxItem";
import { useComboBoxContext } from "./context";
import { Typography } from "@/ui-kit";

export const ComboBoxContent = () => {
  const { t } = useTranslations();
  const {
    filteredOptions,
    contentClassName,
    maxHeight,
    loading,
    loadingMore,
    onLoad,
  } = useComboBoxContext();

  const { containerRef } = useInfiniteScroll({
    onLoad,
    enabled: !loading && !loadingMore && !!onLoad,
  });

  return (
    <div
      ref={containerRef}
      className={clsx("nuco-combobox__content", contentClassName)}
      style={{ maxHeight }}
      role="presentation"
    >
      {loading ? (
        <div className="nuco-combobox__content-loadingState">
          <Skeleton color="layer2" width="100%" height="2.125rem" />
          <Skeleton color="layer2" width="100%" height="2.125rem" />
          <Skeleton color="layer2" width="100%" height="2.125rem" />
        </div>
      ) : (
        <>
          {filteredOptions.map((option, index) => (
            <ComboBoxItem key={option.id} option={option} index={index} />
          ))}

          {filteredOptions.length === 0 && (
            <div className="nuco-combobox__content-emptyState">
              <Typography text={t("ui.comboBox.noResults")} />
            </div>
          )}

          {filteredOptions.length > 0 && onLoad && loadingMore && (
            <div className="nuco-combobox__content-loadingMoreState">
              <Spinner size="sm" color="primary" />
            </div>
          )}
        </>
      )}
    </div>
  );
};
